// The signed-in actor, as the login context picker stored it in localStorage.
//
// A customer contact (a parent, tenant, patient…) reaches only their own customer's documents, through
// the /v1/customers/{cid}/… routes – the backend checks they are a contact of {cid} (ecs-service#786).
// Business users use /v1/merchants/{mid}/….

/** Whether the selected login context is a customer contact. */
export function isCustomerContact() {
  const selectedContext = localStorage.getItem('selectedContext');
  if (!selectedContext) return false;
  try {
    return JSON.parse(selectedContext).actorType === 'CUSTOMER_CONTACT';
  } catch (e) {
    console.error('Failed to parse selectedContext');
    return false;
  }
}

/** The customer id a customer contact acts for, or null for anyone else. */
export function customerContextId() {
  const contextId = localStorage.getItem('contextId') || localStorage.getItem('selectedContextId');
  return isCustomerContact() && contextId ? contextId : null;
}

/** `/v1/customers/{cid}{path}` for a customer contact, else `/v1/merchants/{mid}{path}`. */
export function receiptOwnerPath(mid, path) {
  const cid = customerContextId();
  return cid ? `/v1/customers/${cid}${path}` : `/v1/merchants/${mid}${path}`;
}



// WEBPACK FOOTER //
// ./src/utils/customer.context.js